import { useState } from 'react';
import { Drawer } from '@mweb/zappos-ui/Drawer';
import { Radio } from '@mweb/zappos-ui/Radio';

import { useFilteredSortOptions } from 'hooks/useFilteredSortOptions';
import { filterSortOptions } from 'utils/filterSortOptions';
import { useSortSelectedValue } from 'hooks/useSortSelectedValue';
import type { SortOptionProps } from 'components/search/Sort';

interface SortDrawerProps {
  isBestForYouSortEligible: boolean;
  selectedSort: SortOptionProps;
  onSortSelected: React.ChangeEventHandler<HTMLInputElement>;
}

export const SortDrawer = ({ isBestForYouSortEligible, onSortSelected, selectedSort }: SortDrawerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const sortOptions = useFilteredSortOptions();
  const options = filterSortOptions(sortOptions, !!isBestForYouSortEligible);
  const selectedValue = useSortSelectedValue(options, selectedSort);

  const handleSortSelected: React.ChangeEventHandler<HTMLInputElement> = event => {
    setIsOpen(false);
    onSortSelected(event);
  };

  return (
    <Drawer
      open={isOpen}
      onOpenChange={setIsOpen}
      title="Sort"
      headerClassName="relative"
      position="bottom"
      contentClassName="z-[999] focus:z-[999]"
      overlayClassName="z-[998]"
      titleClassName="absolute inset-0 m-auto flex items-center justify-center"
      triggerSlot={
        <button
          onClick={() => setIsOpen(true)}
          type="button"
          className="z- body-xs-subtle flex h-10 items-center justify-center gap-2 rounded-sm border border-gray-200 px-4 max-sm:w-full sm:w-auto"
        >
          Sort
        </button>
      }
    >
      <div className="flex w-full flex-col">
        {options.map(({ eventLabel, label, value, ariaLabel }) => {
          const isChecked = selectedValue?.value === value;
          return (
            <Radio
              key={value}
              checked={isChecked}
              label={label}
              data-label={eventLabel || label}
              aria-label={ariaLabel || label}
              value={value}
              onChange={handleSortSelected}
              className="h-11"
            />
          );
        })}
      </div>
    </Drawer>
  );
};
